import React, { useContext } from 'react'
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Button } from '@material-ui/core'
import { pointrMinimalLogo, pointrMinimalLogoWhite } from '../../assets/images'
import { MKT_PAGES } from 'config/constants/env'
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth'
import MenuIcon from '@material-ui/icons/Menu'
import usePointrThemedNavbarStyle from './Styles'
import Provider, { PointrThemedNavBarContext, PointrThemedNavBarContextProvider } from './Provider'
import SessionManagerService from 'smart-components/session-manager/Service'
import { IPointrThemedNavbarProps } from './Interfaces'
import cx from 'classnames'

const PointrThemedNavbar: React.FC<IPointrThemedNavbarProps> = ({ width, useBackground }) => {
  const classes = usePointrThemedNavbarStyle({})
  const componentContext = useContext<PointrThemedNavBarContext>(PointrThemedNavBarContextProvider)

  const menuLinkClasses = useBackground ? cx(classes.menuLink, classes.menuLinkWhite) : classes.menuLink

  return (
    <AppBar
      elevation={0}
      position="relative"
      classes={{
        root: useBackground ? classes.appBarRootWithGradiant : classes.appBarRoot
      }}
    >
      <Toolbar>
        <a href={MKT_PAGES.BASE_URL}>
          <img
            id="pointr-logo"
            className={classes.image}
            src={useBackground ? pointrMinimalLogoWhite : pointrMinimalLogo}
            alt="Pointr"
          />
        </a>

        {isWidthUp('sm', width) && (
          <div className={classes.menuBar}>
            <div className={classes.menuItem}>
              <a id="pointr-our-solution-label" className={menuLinkClasses} href={MKT_PAGES.OUR_SOLUTION}>
                Our Solution
              </a>
            </div>
            <div className={classes.menuItem}>
              <a id="pointr-about-label" className={menuLinkClasses} href={MKT_PAGES.ABOUT}>
                About
              </a>
            </div>
            {!!SessionManagerService.state.currentUser && (
              <div className={classes.userActionsContainer}>
                <Button
                  id="pointr-welcome-user-label"
                  classes={{
                    root: classes.userActionsButton
                  }}
                  aria-controls="user-actions"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={event => componentContext.handlers.setUserActionMenuAnchor(event.currentTarget)}
                >
                  Hi, {SessionManagerService.state?.currentUser?.firstName}
                </Button>
                <Menu
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                  }}
                  anchorEl={componentContext.state.userActionsMenuAnchor}
                  open={Boolean(componentContext.state.userActionsMenuAnchor)}
                  onClose={() => componentContext.handlers.setUserActionMenuAnchor(null)}
                  keepMounted
                >
                  <MenuItem
                    id="pointr-sign-out-menu-item-label"
                    className={classes.userActionsMenuItem}
                    onClick={() => SessionManagerService.logOff()}
                  >
                    Sign out
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        )}

        {isWidthDown('sm', width) && (
          <div className={classes.hamburgerMenuContainer}>
            <IconButton
              aria-label="Menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={event => componentContext.handlers.onSetMenuAnchor(event.currentTarget)}
            >
              <MenuIcon className={classes.hamburgerMenu} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              anchorEl={componentContext.state.menuAnchor}
              open={Boolean(componentContext.state.menuAnchor)}
              onClose={() => componentContext.handlers.onSetMenuAnchor(null)}
            >
              <MenuItem href={MKT_PAGES.OUR_SOLUTION} className={classes.hamburgerMenuItem}>
                Our Solution
              </MenuItem>
              <MenuItem href={MKT_PAGES.ABOUT} className={classes.hamburgerMenuItem}>
                About
              </MenuItem>
            </Menu>
          </div>
        )}
      </Toolbar>
    </AppBar>
  )
}

const PointrThemedNavbarWithWidth = withWidth()(PointrThemedNavbar)

PointrThemedNavbarWithWidth.defaultProps = {
  useBackground: false
}

export default ({ useBackground }: { useBackground?: boolean }) => (
  <Provider>
    <PointrThemedNavbarWithWidth useBackground={useBackground} />
  </Provider>
)
